import type { TripsPage } from '../../../types/trips-page'
import { buildTripsPage } from '../../../types/trips-page'
import { normalizeTripSummary } from './TripSummaryNormalizer'

const normalizeTripsPage = function (input: Object): TripsPage {
  return buildTripsPage(input.count, input.page, input.items.map(normalizeTripSummary))
}

export {
  normalizeTripsPage
}



// WEBPACK FOOTER //
// ./src/services/b2b/normalizer/TripsPageNormalizer.js